// Physical finish is separate from rarity/art style. Never infer foil from "Art Rare".
export function canonicalPrinting(value: unknown): string | null {
  const token = String(value ?? "").normalize("NFKC").toLowerCase().replace(/[^a-z0-9]/g, "");
  if (["normal", "nonfoil", "nonholo", "nonholofoil", "standard"].includes(token)) return "Normal";
  if (["holo", "foil", "holofoil", "holographic"].includes(token)) return "Holofoil";
  if (["reverseholo", "reverseholofoil", "reversefoil"].includes(token)) return "Reverse Holofoil";
  if (["pokeballholo", "pokeballholofoil", "pokeballreverseholo", "pokeballreverseholofoil"].includes(token)) return "Poke Ball Holofoil";
  if (["masterballholo", "masterballholofoil", "masterballreverseholo", "masterballreverseholofoil"].includes(token)) return "Master Ball Holofoil";
  return null;
}
export function printingIdentityToken(value: unknown) {
  const text = String(value ?? "").normalize("NFKC").toLowerCase().replace(/[^\p{L}\p{N}.]/gu, "");
  if (["", "unspecified", "printingnotspecified", "unknown", "unconfirmed"].includes(text)) return "";
  return (canonicalPrinting(value) ?? String(value ?? "")).normalize("NFKC").toLowerCase().replace(/[^\p{L}\p{N}.]/gu, "");
}
